import React, { useState, useEffect } from "react";
import useWindowDimensions from "../get-diemensions/UseWindowDiemensions";
import {
  ContactUsPopUp,
  LoadingPopUp,
  LoginPopUp,
  MenuDisplayHeader,
  SignUpPopUp,
} from "../components";
import { useNavigate } from "react-router-dom";
import FacilityCard from "./components/facility-card/FacilityCard";
import { colors } from "../themes/Colors";

const Pharmacies = () => {
  const { width, height } = useWindowDimensions();
  const navigate = useNavigate();
  const [westerncapePharmacies, setWesterncapePharmacies] = useState(null);
  const [kwazuluNatalPharmacies, setKwazuluNatalPharmacies] = useState(null);

  const [signUp, setSignUp] = useState(false);
  const [login, setLogin] = useState(false);
  const [contact, setContact] = useState(false);

  const [loading, setLoading] = useState(false);
  const updateLWesterncapeStores = async () => {
    setLoading(true);
    await fetch(
      "https://rooftop420database.onrender.com/facilities/getFacilities"
    )
      .then((response) => {
        return response.json();
      })
      .then((resData) => {
        setLoading(false);
        setWesterncapePharmacies(resData);
      });
  };
  const updateLKwazullNatalPharmacies = async () => {
    setLoading(true);
    await fetch(
      "  https://rooftop420-dbn-database.onrender.com/facilities/getFacilities"
    )
      .then((response) => {
        return response.json();
      })
      .then((resData) => {
        setLoading(false);
        setKwazuluNatalPharmacies(resData);
      });
  };

  useEffect(() => {
    updateLWesterncapeStores();

    updateLKwazullNatalPharmacies();
  }, []);
  return (
    <div
      style={{
        width: width,
        position: "relative",
        height: height,
        overflowY: "scroll",
        overflowX: "hidden",
        display: "flex",
        flexDirection: "column",
        backgroundColor: colors.bgPrimary,
        alignItems: "center",
      }}
    >
      <MenuDisplayHeader
        width={width}
        selected={"pharmacies"}
        onAboutClick={() => navigate("/")}
        onLegalityClick={() => navigate("/legality")}
        onPractionersClick={() => navigate("/practioner")}
        onSignUpClick={() => setSignUp(true)}
        onLogInClick={() => setLogin(true)}
        onContactClick={() => setContact(true)}
      />
      <div style={{ minHeight: 80 }} />

      <div
        style={{
          display: width > 899 ? "flex" : null,
          flexWrap: "wrap",
          overflowY: "auto",
          justifyContent: "center",
          alignItems: "center",
          width: width,
          maxWidth: 1440,
        }}
      >
        <div
          style={{
            //   marginLeft: 120,
            fontWeight: "bold",
            fontSize: 22,
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: 20,
            marginBottom: 20,
          }}
        >
          WESTERN CAPE
        </div>
        {westerncapePharmacies
          ? westerncapePharmacies.store.map((location, index) => {
              return location.status !== "Pending" &&
                location.status !== "PENDING" &&
                location.status !== "Pipeline" ? (
                <div key={index}>
                  <FacilityCard
                    location={location}
                    // onClick={() => {
                    //   setSelectedLocation(location);
                    //   setShopBreakDown(true);
                    // }}
                  />
                </div>
              ) : null;
            })
          : null}
        <div
          style={{
            //   marginLeft: 120,
            fontWeight: "bold",
            fontSize: 22,
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: 20,
            marginBottom: 20,
          }}
        >
          KWA-ZULU NATAL & GAUTENG
        </div>
        {kwazuluNatalPharmacies
          ? kwazuluNatalPharmacies.store.map((location, index) => {
              return location.status !== "Pending" &&
                location.status !== "PENDING" &&
                location.status !== "Pipeline" ? (
                <div key={index}>
                  <FacilityCard
                    location={location}
                    // onClick={() => {
                    //   setSelectedLocation(location);
                    //   setShopBreakDown(true);
                    // }}
                  />
                </div>
              ) : null;
            })
          : null}
      </div>
      <SignUpPopUp
        display={signUp}
        setClose={() => setSignUp(false)}
        width={width}
      />
      <LoginPopUp
        display={login}
        setClose={() => setLogin(false)}
        width={width}
      />
      <ContactUsPopUp display={contact} setClose={() => setContact(false)} />
      <LoadingPopUp display={loading} />
    </div>
  );
};

export default Pharmacies;
